import PropTypes from "prop-types";
import {
  ListItemText,
  ListItem,
  ListItemButton,
  ListItemIcon,
  SvgIconTypeMap,
} from "@mui/material";
import { FC } from "react";
import { Link, useLocation } from "react-router-dom";
import { OverridableComponent } from "@mui/material/OverridableComponent";
import BoldTypography from "./BoldTypography";

interface SidebarNavItemProps {
  label: string;
  icon: OverridableComponent<SvgIconTypeMap<{}, "svg">>;
  path: string;
}

const SidebarNavItem: FC<SidebarNavItemProps> = ({
  icon: Icon,
  label,
  path,
}) => {
  const location = useLocation();
  const selected = location.pathname === path;
  const color = selected ? "primary" : "textSecondary";
  const iconColor = selected ? "primary" : "action";

  return (
    <ListItem disablePadding>
      <ListItemButton selected={selected} component={Link} to={path}>
        <ListItemIcon>
          <Icon color={iconColor} />
        </ListItemIcon>
        <ListItemText
          primary={<BoldTypography color={color}>{label}</BoldTypography>}
        />
      </ListItemButton>
    </ListItem>
  );
};

SidebarNavItem.propTypes = {
  path: PropTypes.string.isRequired,
  icon: PropTypes.any.isRequired,
  label: PropTypes.string.isRequired,
};

export default SidebarNavItem;
